import { Component, Input, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-work-schedule-form',
    templateUrl: './work-schedule.template.html',
})
export class WorkScheduleForm extends BaseForm {
    @Input() workSchedule: WorkSchedule = new WorkSchedule();
    @ViewChild('form') form: NgForm;
}
